// Visual tokens for the Raffle module — the NDS palette from the Raffle 1
// prototype. Ticket colours and the void reasons mirror the server's
// RaffleRules; the server is the one that validates them.

export const NAVY = '#0a0e2a';
export const NAVY_2 = '#111a4d';
export const INDIGO = '#4a4fba';
export const LAVENDER = '#8b90f0';
export const LAVENDER_SOFT = '#e8e9fd';
export const GREEN = '#0f9d58';
export const GREEN_SOFT = '#e6f6ee';
export const GOLD = '#ffc93c';
export const AMBER = '#b46a00';
export const AMBER_SOFT = '#fdf3e2';
export const RED = '#c62828';
export const RED_SOFT = '#fdeaea';
export const SLATE = '#5b6478';
export const LINE = '#e3e6ef';
export const BG = '#f6f7fb';

export const BALL_COLORS = [
  '#ff4d6d',
  '#ffb020',
  '#ffe14d',
  '#3ddc84',
  '#28c4d9',
  '#4a6cf7',
  '#a855f7',
  '#ff7ac6',
];

export const TICKET_COLORS = [
  { name: 'Red', hex: '#e53935', ink: '#fff', group: 'Standard' },
  { name: 'Blue', hex: '#1e88e5', ink: '#fff', group: 'Standard' },
  { name: 'Green', hex: '#2e9e4f', ink: '#fff', group: 'Standard' },
  { name: 'Yellow', hex: '#ffd54f', ink: '#3a2f00', group: 'Standard' },
  { name: 'Orange', hex: '#fb8c00', ink: '#fff', group: 'Standard' },
  { name: 'Pink', hex: '#ec407a', ink: '#fff', group: 'Standard' },
  { name: 'Purple', hex: '#8e44d0', ink: '#fff', group: 'Standard' },
  { name: 'Brown', hex: '#8d6e63', ink: '#fff', group: 'Standard' },
  { name: 'Gray', hex: '#9aa3b0', ink: '#1a1d26', group: 'Standard' },
  { name: 'White', hex: '#f5f7fa', ink: '#1a1d26', group: 'Standard' },
  { name: 'Neon Green', hex: '#39ff5b', ink: '#062b0d', group: 'Neon' },
  { name: 'Neon Blue', hex: '#1fe0ff', ink: '#04303a', group: 'Neon' },
  { name: 'Neon Pink', hex: '#ff2fb0', ink: '#3d0025', group: 'Neon' },
  { name: 'Neon Orange', hex: '#ff7a1a', ink: '#3d1700', group: 'Neon' },
  { name: 'Neon Yellow', hex: '#f2ff2e', ink: '#33380a', group: 'Neon' },
  { name: 'Neon Purple', hex: '#b14bff', ink: '#26003f', group: 'Neon' },
];

export const colorByName = (n) =>
  TICKET_COLORS.find((c) => c.name === n) || TICKET_COLORS[3];

// R55 — mirrors RaffleRules.VOID_REASONS; the server rejects anything else.
export const VOID_REASONS = [
  'Paid by mistake',
  'Wrong customer',
  'Duplicate entry',
  'Prize never handed out',
];

// R88 — where a brand new auto cycle starts counting; mirrors
// RaffleRules.DEFAULT_AUTO_FROM, and the server applies it when blank.
export const DEFAULT_AUTO_FROM = 10001;

// R29 — the common prizes, so nobody needs the phone keyboard.
export const PRIZE_PRESETS = [25, 50, 100, 200, 300, 500];
export const POT_INCREASE_PRESETS = [300, 500, 1000];

const PASTELS = [
  '#F7C9C9',
  '#F9DDB7',
  '#FBF0B2',
  '#D8F0C0',
  '#BFEBD9',
  '#BEE3F2',
  '#C6D4F7',
  '#D6C9F7',
  '#F0C9EC',
  '#F7C9DC',
  '#E4D5C3',
  '#CFE0E8',
  '#DCE8C9',
  '#F2D9C9',
  '#D2D6E0',
];

export const pastelFor = (s = '') => {
  let h = 0;
  for (let i = 0; i < s.length; i++) h = (h * 31 + s.charCodeAt(i)) % 997;
  return PASTELS[h % PASTELS.length];
};

export const money = (n) =>
  !n ? '$0' : '$' + Number(n).toLocaleString('en-US');

export const pad = (n) =>
  n === null || n === undefined || n === '' ? '--' : String(n).padStart(2, '0');

// A drawn value as it reads on the floor: machine numbers are zero-padded,
// ticket and auto numbers are printed as-is.
export const shownValue = (mode, value) =>
  mode === 'machine' ? pad(value) : String(value ?? '—');

export const bookRange = (b) =>
  b.lastGivenOut >= b.from ? `${b.from}–${b.lastGivenOut}` : 'None out';

export const formatPhone = (p) => {
  const d = String(p || '').replace(/\D/g, '');
  if (d.length !== 10) return p || '';
  return `(${d.slice(0, 3)}) ${d.slice(3, 6)}-${d.slice(6)}`;
};

export const fullName = (c) =>
  `${c?.firstName || ''} ${c?.lastName || ''}`.trim();

// Kept to what an <input inputMode="numeric"> should hold.
export const digitsOnly = (v, max = 7) =>
  String(v || '')
    .replace(/\D/g, '')
    .slice(0, max);
